import { Input } from "@arcadeai/design-system/components/ui/atoms/input";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@arcadeai/design-system/rhf";
import type { Control } from "react-hook-form";
import type { UserSourceCreateRequest } from "../../types";

type NameFormFieldProps = {
  control: Control<UserSourceCreateRequest>;
  autoFocus?: boolean;
};

export function NameFormField({ control, autoFocus }: NameFormFieldProps) {
  return (
    <FormField
      control={control}
      name="name"
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            Name
            <span className="text-destructive"> *</span>
          </FormLabel>
          <FormControl>
            <Input {...field} autoFocus={autoFocus} />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
